var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.level*20+'vw'}),attrs:{"foobar":""}},[_c('h4',[_vm._v("foobar level"+_vm._s(_vm.level))]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":_vm.popup}},[_vm._v("\n    popup\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77226c40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo/CustomComponent/ComponentStack.vue
// module id = null
// module chunks = 